/**
 * Created by Jie Gao on 2018-06-14.
 */
import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {GGGameModuleConfig} from "../../GGGameModuleConfig";
import {GGParsedGameData} from "../../server/data/GGParsedGameData";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {GGGameConfig} from "../../GGGameConfig";
import {BankBrokeView} from "./BankBrokeView";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class BankBrokeController extends FreespinOutroController {
    private _isFreespinMode:boolean;
    private _isDoubleSpins:boolean;

    // #576
    private _started: boolean = false;

    protected parseFeatureGameData(data:GGParsedGameData) {
        this._isFreespinMode = data.isFreespinMode;
        this._isDoubleSpins = (data.doubleBombSpins>-1);
    }

    public start():void {
        // #576
        const data: GGParsedGameData = this._serverData! as GGParsedGameData;
        if (data.brokeBank) {
            GGGameConfig.instance.FAULTY_WIN_CAP = (data.nextMode !== GameMode.NORMAL);
        }
        if (this._started) {
            if (!GGGameConfig.instance.FAULTY_WIN_CAP) {
                (this._view as BankBrokeView).finishPendingWinCap();
            } else {
                super.start();
            }

            return;
        }

        const tl:TimelineLite = new TimelineLite();
        tl.add([
            TweenLite.to(StageManager.stage, 0.5, {y : 0}),
            TweenLite.to(StageManager.stage, 0.5, {x : 0}),
            TweenLite.to(StageManager.stage.scale, 0.5, {x : 1, y : 1})
        ]);
        tl.add(() => {
            super.start();

            // #576
            this._started = true;
        });
    }

    protected calculateIsTriggered(data:GGParsedGameData):boolean {
        return data.brokeBank;
    }

    protected onCloseComplete():void {
        GGGameModuleConfig.featurePrice.reset();
        
        if(this._isDoubleSpins){
            GGGameModuleConfig.fsCounter.hideFlag();
        }
        if(this._isFreespinMode) {
            const tl:TimelineLite = new TimelineLite({
                onComplete : () => super.onCloseComplete()
            });

            tl.add([
                () => {
                    GGGameModuleConfig.fsCounter.hideFlag(true);
                    GGGameModuleConfig.soundPlayer.playCameraPanningSound()
                },
                GGGameModuleConfig.background.panUpDownEffect(true, false)
            ]);
        } else {
            super.onCloseComplete();
        }

        // #576
        this._started = false;
        SlotGame.keypad.setZeroBetSpinCounter(-1);
        GGGameConfig.instance.FAULTY_WIN_CAP = false;
    }
}
